import React from 'react'
import PropTypes from 'prop-types'
import {MenuContent} from '../list-menu/partials/MenuContent'

const DrawerMenuSecondLevel = ({selectedCategory, categoriesData, locale}) => {
    return (
        <MenuContent
            primarycategory={selectedCategory}
            categoriesData={categoriesData}
            locale={locale}
        />
    )
}

DrawerMenuSecondLevel.displayName = 'DrawerMenuSecondLevel'

DrawerMenuSecondLevel.propTypes = {
    selectedCategory: PropTypes.object,
    categoriesData: PropTypes.object,
    locale: PropTypes.object,
}

export {DrawerMenuSecondLevel}
